module.exports = __webpack_public_path__ + "b34aed56b316cb195e435d2633806b05.pdf";